export { default } from './PageLoading'



// WEBPACK FOOTER //
// ./src/modules/common/components/pageloading/index.js